

import { Component, Input, EventEmitter, Output, OnInit, ChangeDetectorRef } from '@angular/core';
import { allBillingColumns, allPaymentColumns, PaymentGridData, paymentColumns } from '../../helpers/grid-helpers';
import { orderListByIds } from '../../helpers/helpers';
import { BudgetSchedule, SaveBudgetCellData } from '../../store/reselectors/budget.data';
import { createId } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BudgetGridComponent } from './budget-grid.component';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';

@Component({
    selector: 'budget-schedule',
    template: `
<div class="schedule-title" *ngIf="!hideTitle">{{ paymentSchedule ? 'Payment' : 'Billing' }} Schedule</div>
<budget-grid 
  *ngIf="gridData?.length" 
  [readOnly]="readOnly" 
  [showDelete]="!readOnly"
  [fullWidth]="fullWidth"
  [columns]="paymentSchedule ? paymentColumns : billingColumns" 
  [rows]="gridData"
  (saveRows)="saveRows($event)"
  (saveCell)="saveCell($event)"
></budget-grid>
<button *ngIf="!readOnly" class="secondary" (click)="addLine()">+ ADD LINE</button>
<div class="totals" [ngClass]="{ fullWidth: fullWidth }" *ngIf="!!schedule?.total">
  <ng-container *ngIf="schedule.pending">
    <div class="total-label">Pending:</div>
    <div class="total-amount">{{ schedule.pending | prettyNumbers:2:1:true }}</div>
  </ng-container>
  <ng-container *ngIf="schedule.paid">
    <div class="total-label">Paid:</div>
    <div class="total-amount">{{ schedule.paid | prettyNumbers:2:1:true }}</div> 
  </ng-container>
  <div class="total-label">Total:</div>
  <div class="total-amount">{{ schedule.total | prettyNumbers:2:1:true }}</div>
</div>

`,
    styleUrls: ['./budget-schedule.scss', './budget-totals.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, PrettyNumbersPipe, BudgetGridComponent],
})
export class BudgetScheduleComponent implements OnInit {
  @Input() paymentSchedule = true
  @Input() hideTitle = false

  @Input() costId: string

  @Input() schedule: BudgetSchedule
  @Input() gridData: PaymentGridData[]
  @Input() readOnly: boolean = true;
  @Input() fullWidth: boolean = false;
  @Output() saveSchedule: EventEmitter<BudgetSchedule> = new EventEmitter()

  paymentColumns = allPaymentColumns
  billingColumns = allBillingColumns

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    setTimeout(() => this.changeDetectorRef.detectChanges(), 5000)
  }

  saveRows(rows: PaymentGridData[]) {
    this.schedule.items = orderListByIds(this.schedule.items, rows.map(r => r.id))
    console.log({ rows, items: this.schedule.items })
    this.saveSchedule.emit(this.schedule)
  }

  saveCell(data: SaveBudgetCellData<PaymentGridData>) {
    console.log(data)
    const { column, saveData, row } = data
    const item = this.schedule.items.find(r => r.id === row.id)
    switch (column.id) {
      case paymentColumns.date:
        item.date = new Date(saveData).getTime()
        break
      case paymentColumns.description:
        item.description = row.description.text
        break
      case paymentColumns.amount:
        item.amount = saveData
        break
      case paymentColumns.status:
        item.status = saveData
        break
      default:
        console.log(`Missing handling for ${column.id}`, data)
        return
    }
    this.saveSchedule.emit(this.schedule)
  }

  
  addLine() {
    this.schedule.items.push({ id: createId(), amount: null, description: '', date: new Date().getTime(), status: 'Pending', costSectionId: this.costId || null })
    this.saveSchedule.emit(this.schedule)
  }

}

